module.exports = __webpack_public_path__ + "img/img3.0d1037b1.jpg";